import { render, staticRenderFns } from "./ChevronDoubleDownIcon.vue?vue&type=template&id=141ca9b9&scoped=true&"
import script from "./ChevronDoubleDownIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ChevronDoubleDownIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141ca9b9",
  null
  
)

export default component.exports